import { render, staticRenderFns } from "./BecomeAVendorFour.vue?vue&type=template&id=0f97fe66"
import script from "./BecomeAVendorFour.vue?vue&type=script&lang=js"
export * from "./BecomeAVendorFour.vue?vue&type=script&lang=js"
import style0 from "./BecomeAVendorFour.vue?vue&type=style&index=0&id=0f97fe66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports